import { Link } from "react-router-dom";
import { Col } from "reactstrap";
import SvgIcon from "../../../coreComponents/SvgIcon";
import { routes } from "../../../routers/routes";
import { dynamicImage } from "../../../utils";
import { useAppDispatch } from "../../../reduxToolkit/hooks";
import { toggleSidebar } from "../../../reduxToolkit/reducers/layout/themeCustomizerSlice";
import { Image } from "../../../coreComponents/Image";

const LogoWrapper = () => {
  const dispatch = useAppDispatch();

  return (
    <Col className="header-logo-wrapper col-auto p-0">
      <div className="logo-wrapper">
        <Link to={routes.Sample}>
          <Image className="img-fluid for-light" src={dynamicImage(`logo/logo.png`)} alt="" />
          <Image className="img-fluid for-dark" src={dynamicImage(`logo/logo_dark.png`)} alt="" />
        </Link>
      </div>
      <div className="toggle-sidebar" onClick={() => dispatch(toggleSidebar())}>
        <SvgIcon className="sidebar-toggle" iconId="stroke-animation" />
      </div>
    </Col>
  );
};
export default LogoWrapper;
